import { Injectable } from '@angular/core';
import Toastify from 'toastify-js';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private show(message: string, className: string) {
    Toastify({
      text: message,
      gravity: "top",
      position: "center",
      className: `p-2 small fs-5 rounded-2 ${className}`, // 👈 style tweak
      duration: 3000,
      close: true,
      stopOnFocus: true
    }).showToast();
  }

  success(msg: string) { this.show(msg, "bg-success text-white"); }
  error(msg: string)   { this.show(msg, "bg-danger text-white"); }
  warning(msg: string) { this.show(msg, "bg-warning text-dark"); }
  info(msg: string)    { this.show(msg, "bg-info text-white"); }
}
